import Sentiment from 'sentiment';
import * as Readability from 'text-readability';

class Statistics {
  static instance: Statistics;

  static getInstance() {
    if (!Statistics.instance) Statistics.instance = new Statistics();
    return Statistics.instance;
  }

  analyzeSentiment = (text: string) => {
    const sentiment = new Sentiment();
    const sentimentObj = sentiment.analyze(text);

    let sentimentText = 'Neutral';
    if (sentimentObj.score > 0) {
      sentimentText = 'Positive';
    } else if (sentimentObj.score < 0) {
      sentimentText = 'Negative';
    }
    return sentimentText;
  };

  countParagraphs = (text: string) => {
    const paras = text.split('\n').filter((para) => para.trim().length > 0);
    return paras.length;
  };

  fleschScore = (text: string) => {
    const score = Readability.fleschReadingEase(text);
    const grad = Readability.fleschReadingEaseToGrade(score);
    return [score, grad];
  };

  consensus = (text: string) => {
    const consensusScore = Readability.textStandard(text);
    const gradLevel = consensusScore.split('and');
    return gradLevel[1].trim() || gradLevel[0];
  };

  readingTime = (wordCount: number, wordsPerMinute = 250) => {
    const readTime = wordCount / wordsPerMinute;
    const minutes = Math.floor(readTime);
    const seconds = ((readTime - minutes) * 60).toFixed();
    return `${minutes} mins ${seconds} secs`;
  };
}

export default Statistics;
export { Statistics };
